import axios from '@/util/requestUtil'

// 用户信息、交易帐号信息
export function getUserInfo () {
  return axios.get(`/eddid/info`)
}
export function customerAgreement (params) {
  return axios.post(`/eddid/agreement/agree`, params)
}
export function getAgreementContent (params) {
  return axios.post(`/eddid/agreement/content`, params)
}
